import { Injectable } from '@angular/core';
import { FeeType, PaymentFrequency, PaymentFrequencyLabel } from "../application/application.model";

@Injectable({
  providedIn: 'root'
})
export class AccountTransferService {
    calculateFeeAmount(amount: number, fee: number, feeType: FeeType): number {
    if (feeType === FeeType.Percentage)
      return amount * fee / 100;
    else
      return fee;
  }

  calculateDisbursedAmount(amount?: number, feeAmount?: number): number {
    return (amount || 0) - (feeAmount || 0);
  }

  calculateTotalInterest(amount: number, rate: number): number {
    return Math.round(amount * rate) / 100.0;
  }

  getTotalNumberOfPayments(paymentFrequency: PaymentFrequency, term: number): number {
    switch (paymentFrequency) {
      case PaymentFrequency.BiWeekly:
        return Math.round(term * 26 / 12);

      case PaymentFrequency.Monthly:
        return term;

      default:
        return Math.round(term * 52 / 12);
    }
  }

  calculatePayments(amount: number, totalInterest: number, paymentFrequency: PaymentFrequency, term: number): number {
    return (amount + totalInterest) / this.getTotalNumberOfPayments(paymentFrequency, term);
  }

  getLoanOfferPaymentFrequencyLabel(paymentFrequency: PaymentFrequency): string {
    return PaymentFrequencyLabel.get(paymentFrequency);
  }

}
